import React, { useState, useContext } from 'react';
export const DEFAULT_PREVIEW_CONTROL_VALUE = {
    setFindInDocCallback: () => { },
    setPrintCallback: () => { },
    setSelectVideoQualityCallback: () => { },
    setVideoPlayer: () => { },
    setGetPageForSelection: () => { },
};
export const PreviewControlContext = React.createContext(DEFAULT_PREVIEW_CONTROL_VALUE);
function wrapCallback(setter) {
    // since setState(cb) would treat the callback as a reducer for the state, we have to write setState(() => cb) instead
    return (cb) => setter(() => cb);
}
export const PreviewControlProvider = (props) => {
    const [videoPlayer, setVideoPlayer] = useState(undefined);
    const [onFindInDoc, setFindInDocCallback] = useState(undefined);
    const [onPrint, setPrintCallback] = useState(undefined);
    const [onSelectVideoQuality, setSelectVideoQualityCallback] = useState(undefined);
    const [getPageForSelection, setGetPageForSelection] = useState(undefined);
    const setters = React.useMemo(() => ({
        setFindInDocCallback: wrapCallback(setFindInDocCallback),
        setPrintCallback: wrapCallback(setPrintCallback),
        setSelectVideoQualityCallback: wrapCallback(setSelectVideoQualityCallback),
        setVideoPlayer,
        setGetPageForSelection: wrapCallback(setGetPageForSelection),
    }), []);
    const contextValue = React.useMemo(() => ({
        videoPlayer,
        onFindInDoc,
        onPrint,
        onSelectVideoQuality,
        getPageForSelection: getPageForSelection,
        ...setters,
    }), [videoPlayer, onFindInDoc, onPrint, onSelectVideoQuality, getPageForSelection, setters]);
    return (React.createElement(PreviewControlContext.Provider, { value: contextValue }, props.children));
};
PreviewControlProvider.displayName = "PreviewControlProvider"
/**
 * Adding this wrapper to handle the callback and client registion for class components as hook cannot be used
 * directly in these components
 */
export const PreviewControlWrapper = (props) => {
    const { getPageForSelection } = props;
    const { setGetPageForSelection } = useContext(PreviewControlContext);
    React.useEffect(() => {
        if (getPageForSelection) {
            setGetPageForSelection(getPageForSelection);
        }
        return () => {
            if (getPageForSelection) {
                setGetPageForSelection(undefined);
            }
        };
    }, [getPageForSelection, setGetPageForSelection]);
    return React.createElement(React.Fragment, null, props.children);
};
PreviewControlWrapper.displayName = "PreviewControlWrapper"
export const usePreviewControls = () => {
    return useContext(PreviewControlContext);
};
//# sourceMappingURL=preview_controls.preenvesnextjs.map
